import { ValidationError } from 'yup';
export const useYupSchemaValidation = () => {
    const validate = (formData, 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    formSchema) => {
        try {
            const result = formSchema.validateSync(formData, {
                abortEarly: false,
                stripUnknown: true,
            });
            return { hasErrors: false, result };
        }
        catch (error) {
            const errs = {};
            if (error instanceof ValidationError) {
                for (const err of error.inner) {
                    errs[err?.path || 'form_error'] = 'Error: ' + err.message;
                }
            }
            return { hasErrors: true, errors: errs };
        }
    };
    return [validate];
};
export default useYupSchemaValidation;
